import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import  ExScheduling  from './examSchedulingFold/exSchedScheduler';
import  Exclusion  from './examSchedulingFold/exSchedExcluder';
import  Template  from './examSchedulingFold/exSchedTemplate';
import { Form, Input, FormGroup, Label } from 'reactstrap';
import moment from 'moment';
import { connect } from 'react-redux';


class ExamScheduling extends Component {
    static displayName = ExamScheduling.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            activeView: "template",
            activeTerm: "",
            termList: [",", "."],
            lockScheduling: true,
            editLock: false
        }
        this.testPermission();
        this.getSemesters();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username,
        });
        //this.recordComingHere();
        this.testPermission();
        this.getSemesters();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1034",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1034"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async getSemesters() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetExamTerms', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            termList: data
            })
    }

    componentDidMount() {

    }

    async countTemplate(input) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: input
        }
        const response = await fetch('CountTemplate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
            this.setState({
                lockScheduling: data
                })
    }

    receiveRecount = () => {
        this.countTemplate(this.state.activeTerm);
    }

    changeActive(fresh) {
        //if (fresh === "schedule") {
        //    //console.log("need to fire generate");
        //}
        this.setState({
            activeView: fresh
        })
    }

    chooseTerm(e) {
        e.preventDefault();
        this.setState({
            activeTerm: e.target.value,
            activeView: "template"
        })
        this.countTemplate(e.target.value);
        this.isLocked(e.target.value);
    }

    async isLocked(input) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: input
        }
        const response = await fetch('ExamEditLock', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            editLock: data
        })
    }

    displayPageFunc() { 
        return(//Unlike most times that we have a sub-render like this, here we need to have that controlling the page view selector since the major control is going to be against the semester
        <div>
            <Form className="rightAlignCustom">
                    <FormGroup check inline>
                        &nbsp;<Input checked={this.state.activeView == "template" ? true : false} type="radio" name="activeFlip" id="activeFlip" onChange={() => this.changeActive("template")} /><Label>Exam Week Mapping</Label>
                    </FormGroup>
                <FormGroup check inline>
                        &nbsp;<Input type="radio" checked={this.state.activeView == "exclude" ? true : false} name="activeFlip" id="activeFlip" onChange={() => this.changeActive("exclude")} /><Label>Excluder</Label>
                </FormGroup>
                    {!this.state.lockScheduling && <FormGroup check inline>
                        <Input type="radio" checked={this.state.activeView == "schedule" ? true : false} name="activeFlip" id="activeFlip" onChange={() => this.changeActive("schedule")} /><Label>Scheduler</Label>
                    </FormGroup>}
            </Form>
                <br />{/*Despite the fact that I have two <br />s in here, this doesn't actually do much*/ }
                <br />
                {this.state.activeView == "schedule" && <ExScheduling activeTerm={this.state.activeTerm} key={this.state.activeTerm} userData={this.props.reduxData.userInfo} editLock={this.state.editLock} />}
                {this.state.activeView == "exclude" && <Exclusion activeTerm={this.state.activeTerm} key={this.state.activeTerm} userData={this.props.reduxData.userInfo} editLock={this.state.editLock} />}
                {this.state.activeView == "template" && <Template activeTerm={this.state.activeTerm} key={this.state.activeTerm} userData={this.props.reduxData.userInfo} recheckLock={this.receiveRecount} editLock={this.state.editLock} />}
            </div>
            )
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        let displayPage = <div></div>
        if (this.state.activeTerm != "") displayPage = this.displayPageFunc();
        return (
            <UserContext.Consumer>
                {contextData => (
                    <div>
                        <div className="inlineCustom"><Input type="select" name="semester" id="semester" defaultValue="DEFAULT" onChange={(e) => this.chooseTerm(e) }>
                            <option value="DEFAULT" disabled>Select...</option>
                            {this.state.termList.map(option => (
                                <option>{option.semester}</option>
                                )) }
                        </Input>
                        </div>
                        <br />
                        {displayPage}
                    </div>
                )}
            </UserContext.Consumer>
        );
    }

}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(ExamScheduling);